module.exports = __webpack_public_path__ + "img/snoskredforsvaret.67ef15f4.jpg";